export default __webpack_public_path__ + "static/media/SL.04b633de.svg";